import Vue from "vue";
import Router from "vue-router";
// 手机
import index from "@/components/iphone/index";
import introduce from "@/components/iphone/introduce";
import journalism from "@/components/iphone/journalism";
import cooperation from "@/components/iphone/cooperation";
import contactUs from "@/components/iphone/contactUs";
import productCenter from "@/components/iphone/productCenter";
import business from "@/components/iphone/business";
import test from "@/components/iphone/test";
import message from "@/components/iphone/message";
import generalLaw from "@/components/iphone/generalLaw";
// 农特
import specialSupplyMobile from "@/components/iphone/specialSupplyMobile";
// 网页
import homePage from "@/components/homePage";
import group from "@/components/group";
import news from "@/components/news";
import contactWe from "@/components/contactWe";

// 农特
import specialSupplyPc from "@/components/specialSupplyPc";
import appIntroduce from "@/components/appIntroduce";

// 仓库
import store from "@/store";

// 挂载
Vue.use(Router);

const routes = [
  // 手机端
  {
    path: "/index",
    name: "index",
    component: index
  },
  {
    path: "/introduce",
    name: "introduce",
    component: introduce
  },
  {
    path: "/journalism",
    name: "journalism",
    component: journalism
  },
  {
    path: "/cooperation",
    name: "cooperation",
    component: cooperation
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs
  },
  {
    path: "/productCenter",
    name: "productCenter",
    component: productCenter
  },
  {
    path: "/business",
    name: "business",
    component: business
  },
  {
    path: "/message",
    name: "message",
    component: message
  },
  {
    path: "/specialSupplyMobile",
    name: "specialSupplyMobile",
    component: specialSupplyMobile
  },
  {
    path: "/generalLaw",
    name: "generalLaw",
    component: generalLaw
  },
  // pc端
  {
    path: "/homePage",
    name: "homePage",
    component: homePage
  },
  {
    path: "/group",
    name: "group",
    component: group
  },
  {
    path: "/news",
    name: "news",
    component: news
  },
  {
    path: "/contactWe",
    name: "contactWe",
    component: contactWe
  },
  {
    path: "/specialSupplyPc",
    name: "specialSupplyPc",
    component: specialSupplyPc
  },
  {
    path: "/appIntroduce",
    name: "appIntroduce",
    component: appIntroduce
  },
  {
    path: "/test",
    name: "test",
    component: test
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  //路由映射关系
  routes
});

router.beforeEach((to, from, next) => {
  store.dispatch("handleRouteChange", { to, from });
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js